import { Referral } from '@kanda-libs/ks-frontend-services';

import { createSelector } from '@reduxjs/toolkit';
import { selectors } from 'store';

const getFilteredPartners = createSelector(
  selectors.getPathKey,
  selectors.partner.getEntitiesAsArray,
  ({ id }, partners) => {
    if (!id) return partners;
    return partners.filter((partner) =>
      (partner.contact_info.trading_name || '')
        .toLowerCase()
        .includes(id.toLowerCase()),
    );
  },
);

const getFilteredReferrals = createSelector(getFilteredPartners, (partners) =>
  partners.reduce(
    (acc, partner) => [...acc, ...(partner.referrals || [])],
    [] as Referral[],
  ),
);

const partnerSelectors = {
  ...selectors.partner,
  getFilteredPartners,
  getFilteredReferrals,
};

export default partnerSelectors;
